import { Component, Input, Injector } from '@angular/core';
import { BaseControlValueAccessor } from '../../../../shared/core/base-control-value-accessor';
import { TypeJuridiction } from '../../../../entities/type-juridiction';
import { SectionState } from '../../../../shared/components/section/section.model';
import { SiteJuridiction } from '../../../../entities/site-juridiction';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'jhi-site-juridiction-section',
    templateUrl: './site-juridiction-section.component.html',
    styleUrls: ['./site-juridiction-section.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SiteJuridictionSectionComponent,
            multi: true
        }
]
})
export class SiteJuridictionSectionComponent extends BaseControlValueAccessor {

    @Input()
    typeJuridiction: TypeJuridiction;

    state: SectionState = {index: 2, isHelpOpen: true, isToggleable: false};

    siteJuridictionId: string;

    siteJuridiction: SiteJuridiction;

    constructor(injector: Injector) {
        super(injector);
    }

    protected modelValueChanged(value: SiteJuridiction): void {
        this.siteJuridictionId = value && value.id.toString();
        this.siteJuridiction = value;
    }

    onSiteJuridictionChange(value: string) {
        this.onChange(this.siteJuridiction = this.typeJuridiction.siteJuridictions.find(siteJuridiction => siteJuridiction.id === +value));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/juridiction/site-juridiction-section/site-juridiction-section.component.ts